/**
 * URL 校验工具 - 防止 iframe 注入漏洞
 * 验证 URL 是否来自可信域名
 */

// 可信域名白名单
const TRUSTED_DOMAINS = [
  'page.meituan.net',
  'greentech.meituan.com',
  'shangou.meituan.net',
];

/**
 * 验证 URL 是否来自可信域名
 * @param {string} url - 需要校验的 URL
 * @returns {boolean} - 是否通过校验
 */
export const isUrlTrusted = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    const urlObj = new URL(url);

    // 只允许 HTTPS 协议
    if (urlObj.protocol !== 'https:') {
      return false;
    }

    // 检查域名是否在白名单中
    const hostname = urlObj.hostname;
    return TRUSTED_DOMAINS.some((domain) => {
      const isDomainMatch = hostname === domain;
      const isSubdomainMatch = hostname.endsWith(`.${domain}`);
      return isDomainMatch || isSubdomainMatch;
    });
  } catch (error) {
    // URL 格式错误
    return false;
  }
};

/**
 * 获取安全的 iframe src 属性值
 * @param {string} url - 原始 URL
 * @param {string} defaultUrl - 校验失败时的默认 URL（可选）
 * @returns {string|null} - 校验通过返回 URL，否则返回 null 或 defaultUrl
 */
export const getSafeIframeSrc = (url, defaultUrl = null) => (
  isUrlTrusted(url) ? url : defaultUrl
);
